import { render, staticRenderFns } from "./Azione.vue?vue&type=template&id=571a6754&scoped=true&"
import script from "./Azione.vue?vue&type=script&lang=js&"
export * from "./Azione.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "571a6754",
  null
  
)

export default component.exports